import { Action, Dispatch } from "redux";


export const UPDATE_MOODBANNERHEIGHT = "UPDATE_MOODBANNERHEIGHT";

export interface UpdateMoodBannerHeightAction extends Action {
    type: typeof UPDATE_MOODBANNERHEIGHT;
    moodBannerHeight: number;
}